import { I3Model } from '../components/Map3d/components/model';

export const isValidEmail = (email: string) =>
  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    email,
  );

export const isValidPass = (pass: string) =>
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\W])(?=.{8,})/.test(pass);

export const isNumber = (val: string) => /^[0-9]+$/.test(val);

export const getQueryFromLocation = () =>
  new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop: any) => searchParams.get(prop),
  });

export const generateWebsiteApprovalDeepLink = (websiteURL: string) =>
  `metamask://approve?requestingSite=${encodeURIComponent(websiteURL)}`;

export const generateKey = (pre: string) => `${pre}_${new Date().getTime()}`;

export const copyTextToClipboard = async (text: string) => {
  if ('clipboard' in navigator) {
    return await navigator.clipboard.writeText(text);
  }
};

export const getRandomInt = (min: any, max: any) => {
  min = Math.ceil(min);
  max = Math.floor(max);

  return Math.floor(Math.random() * (max - min)) + min;
};

export const usersMostVolumeLevel = (arr: []) =>
  arr.filter((prev: any, current) => (prev.level > 6 ? prev : current));

export const sortArrayByName = (x: any, y: any) => {
  if (x.name.toLowerCase() < y.name.toLowerCase()) {
    return -1;
  }
  if (x.name.toLowerCase() > y.name.toLowerCase()) {
    return 1;
  }
  return 0;
};

export const microphoneOptionGenerate = (
  id: number,
  status: string,
  roomId: number,
) => ({
  user_public_id: id,
  room_public_id: roomId,
  event: status,
});

export const capitalize = (string: string) =>
  string.toString()[0].toUpperCase() + string.toString().slice(1);

const compare = (a: any, b: any, value: any) => {
  const nameA = a.username?.toLowerCase();
  const nameB = b.username?.toLowerCase();

  let comparison = 0;

  if (nameA.indexOf(value) > nameB.indexOf(value)) {
    comparison = 1;
  } else if (nameA.indexOf(value) < nameB.indexOf(value)) {
    comparison = -1;
  }

  return comparison;
};

export const customSort = (data: any, value: string) =>
  data
    .filter((user: any) =>
      user.username.toLowerCase().includes(value.toLowerCase()),
    )
    .sort((a: any, b: any) => compare(a, b, value));

export const downloadFile = (url: string, filename: string) => {
  fetch(url)
    .then((response) => response.blob())
    .then((blob) => {
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      link.click();
    })
    .catch(console.error);
};

export const getVideoDimensions = (videoElement: any) =>
  new Promise((resolve, reject) => {
    videoElement.addEventListener('loadedmetadata', () => {
      resolve({
        width: videoElement.videoWidth.toString(),
        height: videoElement.videoHeight.toString(),
        videoElement,
      });
    });

    videoElement.addEventListener('error', (e: any) => {
      console.warn('ERROR: ', e.message);
      reject(e);
    });
  });

export const toHHMMSS = (secs: any) => {
  const secNum = parseInt(secs, 10);
  const hours = Math.floor(secNum / 3600);
  const minutes = Math.floor((secNum % 3600) / 60);
  const seconds = secNum % 60;

  return [hours, minutes, seconds]
    .map((v) => v.toString().padStart(2, '0'))
    .join(':');
};

export const replaceKey = (obj: any, oldKey: string, newKey: string) => {
  const updatedObj: any = {};
  Object.entries(obj).forEach(([key, value]) => {
    const updatedKey = key === oldKey ? newKey : key;
    updatedObj[updatedKey] = value;
  });
  return updatedObj;
};

export const sizeInMB = (sizeInBytes: any) =>
  (sizeInBytes / (1024 * 1024)).toFixed(2);

export const ipfsUriToUrl = (str: string) => {
  const baseGatewayUrl = 'https://ipfs.bahamut.io/ipfs/';
  if (str.includes('ipfs://')) {
    const ipfsHash = str.replace('ipfs://', '');
    return baseGatewayUrl + ipfsHash;
  }
  return str;
};

export const calcMapCoordinates = (coordinates: any): any[] => {
  let west = coordinates[0];
  let east = coordinates[0];
  let north = coordinates[0];
  let south = coordinates[0];
  for (const coord of coordinates) {
    if (coord[0] > north[0]) {
      north = coord;
    }
    if (coord[0] < south[0]) {
      south = coord;
    }
    if (coord[1] < west[1]) {
      west = coord;
    }
    if (coord[1] > east[1]) {
      east = coord;
    }
  }
  return [west, east, north, south] as any[];
};

export const removeElement = (array: any, from: any, to?: any) => {
  if (from > array.length - 1) return array;
  const rest = array.slice((to || from) + 1 || array.length);
  array.length = from < 0 ? array.length + from : from;
  return array.push.apply(array, rest);
};

export const convert = (numberWithDecimal: number) =>
  Math.round(numberWithDecimal * 10) / 10;

export const genderStringify = ['', 'Male', 'Female'];
export const getFileSize = (num: number): number => {
  const size = `${num / (1024 * 1024)}`;
  return Number(size.slice(0, 5));
};

export const truncateText = (text = '', length: number) => {
  if (typeof text === 'string' && text.length <= length) {
    return text;
  }

  return `${text.slice(0, length)}\u2026`;
};

export const calculateTimeUntil = (
  targetDtae: Date | number,
  joinType = ' / ',
): string => {
  const differenceInMs = +new Date(targetDtae) - +new Date();
  const dateObj = {
    years: 0,
    months: 0,
    days: Math.floor(differenceInMs / DAYS_TO_MILLISECONDS),
    hours: Math.floor((differenceInMs / HOURS_TO_MILLISECONDS) % 24),
    minutes: Math.floor((differenceInMs / MINUTES_TO_MILLISECONDS) % 60),
    seconds: Math.floor((differenceInMs / SECONDS_TO_MILLISECONDS) % 60),
  };

  return formatDuration(dateObj, joinType);
};

const formatDuration = (duration: any, joinType: string): string => {
  const parts = [];
  if (duration.years && duration.years > 0) parts.push(`${duration.years}y`);
  if (duration.months && duration.months > 0) parts.push(`${duration.months}m`);
  if (duration.days && duration.days > 0) parts.push(`${duration.days}d`);
  if (duration.hours && duration.hours > 0) parts.push(`${duration.hours}h`);
  if (duration.minutes && duration.minutes > 0) {
    parts.push(`${duration.minutes}min`);
  }
  if (duration.seconds && duration.seconds > 0) {
    parts.push(`${duration.seconds}sec`);
  }
  return parts.join(joinType);
};

const api = 'https://fv-media.storage.googleapis.com/';
export const transformModelData = (data: any): I3Model[] =>
  data.map((item: any) => ({
    path: api + item.model,
    position: {
      x: item.position_x,
      y: item.position_y,
      z: item.position_z,
    },
    scale: {
      x: item.scale_x,
      y: item.scale_y,
      z: item.scale_z,
    },
    rotation: {
      x: item.rotation_x,
      y: item.rotation_y,
      z: item.rotation_z,
    },
    public_id: item.id,
  }));

export const SECONDS_TO_MILLISECONDS = 1000;
export const MINUTES_TO_MILLISECONDS = 60 * SECONDS_TO_MILLISECONDS;
export const HOURS_TO_MILLISECONDS = 60 * MINUTES_TO_MILLISECONDS;
export const DAYS_TO_MILLISECONDS = 24 * HOURS_TO_MILLISECONDS;

export type TTimeKick = {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
};

export const getKickEndTime = (time: string): TTimeKick => {
  const specificDate: any = new Date(time);
  const currentDate: any = new Date();
  const differenceInMs = specificDate - currentDate;
  let timeLeft;

  if (time) {
    timeLeft = {
      days: Math.floor(differenceInMs / DAYS_TO_MILLISECONDS),
      hours: Math.floor((differenceInMs / HOURS_TO_MILLISECONDS) % 24),
      minutes: Math.floor((differenceInMs / MINUTES_TO_MILLISECONDS) % 60),
      seconds: Math.floor((differenceInMs / SECONDS_TO_MILLISECONDS) % 60),
    };
    return timeLeft;
  }
  return {
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  };
};

export const generateMetamaskMessage = (
  account: string,
  nonce: string,
  domain: string,
) =>
  `${domain} wants you to sign in with your Ethereum account:\n${account}\n\nI accept the Cerebrum Terms of Service: ${domain}/terms\n\nURI: ${domain}\nVersion: 1\nChain ID: 5165\nNonce: ${nonce}\nIssued At: ${new Date().toISOString()}`;

export const parseSearchData = (search: any, page = 1) => {
  if (search.size) {
    const queries = JSON.parse(
      `{"${decodeURI(search.toString())
        .replace(/"/g, '\\"')
        .replace(/&/g, '","')
        .replace(/%2C/g, ',')
        .replace(/=/g, '":"')}"}`,
    );
    Object.keys(queries).forEach((key: any) => {
      if (queries[key].includes(',')) {
        queries[key] = `[${queries[key]}]`;
      }
    });
    delete queries.listModeActive;
    queries.page = page;
    return queries;
  }
  if (page !== 1) {
    return {
      page,
    };
  }
  return {};
};

export const formatDate = (date: Date | string, formatType = 'yyyy-MM-dd') => {
  const convertDate = new Date(date);
  const year = convertDate.getFullYear().toString();
  const month = `00${(convertDate.getMonth() + 1).toString()}`.slice(-2);
  const day = `00${convertDate.getDate().toString()}`.slice(-2);
  const hour = `00${convertDate.getHours().toString()}`.slice(-2);
  const minute = `00${convertDate.getMinutes().toString()}`.slice(-2);

  return formatType
    .replace('yyyy', year)
    .replace('MM', month)
    .replace('dd', day)
    .replace('HH', hour)
    .replace('mm', minute);
};

export const formatDateRange = (start: string, end: string): string => {
  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];

  const startDate = new Date(start);
  const endDate = new Date(end);

  const startMonth = months[startDate.getMonth()];
  const endMonth = months[endDate.getMonth()];

  const startDay = startDate.getDate();
  const endDay = endDate.getDate();

  if (startMonth === endMonth) {
    return `${startMonth} ${startDay}-${endDay}`;
  }
  return `${startMonth} ${startDay}-${endMonth} ${endDay}`;
};

export const countNights = (
  checkInDay: string,
  checkOutDay: string,
): number => {
  const startDate = new Date(checkInDay);
  const endDate = new Date(checkOutDay);
  const differenceInMilliseconds = endDate.getTime() - startDate.getTime();
  const differenceInDays = differenceInMilliseconds / (1000 * 60 * 60 * 24);

  return differenceInDays;
};

export const mapTransformRoomDataToMarker = (room: any) => {
  const { countryData, logo, name, id, location } = room;

  return {
    latitude: location?.latitude || 0,
    longitude: location?.longitude || 0,
    address: countryData?.countryLocation?.address || null,
    popupInfo: {
      id,
      eventData: null,
      roomName: name || 'Unknown',
      previewImage: logo || '',
    },
    type: room?.type || 'price',
    price: room?.price || 0,
  };
};

export const formatLabel = (str: string) =>
  str?.replace(/([A-Z])/g, ' $1').replace(/^./, (s) => s.toUpperCase());

export const fourYearsFromToday = new Date(
  Date.now() - 4 * 365 * 24 * 3600000 - 24 * 3600000,
);

export const minDateForBirth = new Date(1900, 0, 1);
export const stringifyTime = (time: { hours: string; minutes: string }) =>
  time.hours
    ? `00${time.hours}`.slice(-2) +
      (time.minutes ? `:${`00${time.minutes}`.slice(-2)}` : ':00')
    : '';

export const transformDataUserEvent = (event: any) => {
  const time = event?.start_date.split(' ')[1];
  return {
    previewImage: event?.room?.image || '',
    name: event?.room?.name || '',
    id: event?.room?.id || 0,
    time: time || 0,
    creator: {
      username: 'Yocerebrum',
    },
  };
};

const iaArrayParams: any = {
  country: true,
  cities: true,
};

export const transformSearchData = (search: any, page = 1) => {
  const queries: any = {};
  Object.keys(search).forEach((key: any) => {
    if (iaArrayParams[key]) {
      queries[key] = `[${search[key]}]`;
    } else {
      queries[key] = search[key];
    }
  });
  delete queries.listModeActive;
  queries.page = page;
  return queries;
};
